import { handleActions } from 'redux-actions';
import camelCase from 'lodash/camelCase';
import {
  updateModule,
  purgeAllModules,
  fetchModulesSuccess,
  fetchModuleSuccess,
  fetchModuleEndpoint,
  fetchModuleEndpointSuccess,
  fetchModuleEndpointError,
  fetchModuleEndpointPurgeData,
} from '../actions/modules';
import { Module } from '../../types/modules';
import { removeModuleSuccess } from '../actions/layout';
import { ModuleSlice } from '../../types/store';

const defaultState = {} as ModuleSlice;

export default handleActions<any, any>(
  {
    [fetchModulesSuccess.toString()]: (state, action) => {
      const { modules } = action.payload;
      return {
        ...state,
        ...(modules || []).reduce(
          (result: Record<number, Module>, current: Module) => {
            result[current.id] = current;
            return result;
          },
          {}
        ),
      };
    },
    [fetchModuleSuccess.toString()]: (state, action) => ({
      ...state,
      [action.payload.id]: {
        ...action.payload,
      },
    }),
    [removeModuleSuccess.toString()]: (state, action) => {
      const { [action.payload.moduleId]: remove, ...rest } = state;
      return rest;
    },
    [updateModule.toString()]: (state, action) => ({
      ...state,
      [action.payload.id]: {
        ...(state[action.payload.id] || {}),
        moduleData: {
          ...(state[action.payload.id]?.moduleData || {}),
          [camelCase(state[action.payload.id]?.moduleData?.dataKey)]: {
            ...(state[action.payload.id]?.moduleData[
              camelCase(state[action.payload.id]?.moduleData?.dataKey)
            ] || {}),
            ...(action.payload.moduleData || {}),
          },
        },
        moduleMeta: {
          ...(state[action.payload.id]?.moduleMeta || {}),
          ...(action.payload.moduleMeta || {}),
        },
      },
    }),
    [fetchModuleEndpointPurgeData.toString()]: (state, action) => ({
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        requests: {
          ...(state[action.payload.id]?.requests || {}),
          [action.payload.path]: undefined,
        },
      },
    }),
    [fetchModuleEndpoint.toString()]: (state, action) => ({
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        requests: {
          ...(state[action.payload.id]?.requests || {}),
          [action.payload.path]: {
            path: action.payload.path,
            response: undefined,
            isFetching: true,
            errorDescription: undefined,
            ts: Date.now(),
          },
        },
      },
    }),
    [fetchModuleEndpointSuccess.toString()]: (state, action) => ({
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        version:
          action.payload?.response?.config?.version ||
          state[action.payload.id].version,
        requests: {
          ...(state[action.payload.id]?.requests || {}),
          [action.payload.path]: {
            ...(state[action.payload.id]?.requests?.[action.payload.path] ||
              {}),
            path: action.payload.path,
            response: action.payload.response,
            isFetching: false,
            errorDescription: undefined,
          },
        },
      },
    }),
    [fetchModuleEndpointError.toString()]: (state, action) => ({
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        requests: {
          ...(state[action.payload.id]?.requests || {}),
          [action.payload.path]: {
            ...(state[action.payload.id]?.requests?.[action.payload.path] ||
              {}),
            path: action.payload.path,
            response: action.payload.response,
            isFetching: false,
            errorDescription: action.payload.errorDescription,
          },
        },
      },
    }),
    [purgeAllModules.toString()]: () => ({}),
  },
  defaultState
);
